module.exports = __webpack_public_path__ + "static/media/Rectangle573.3f168625.svg";